/**
 * A global namespace for `gestureend` event.
 */
const gestureendEvent = "gestureend";
export default gestureendEvent;
